module.exports = __webpack_public_path__ + "img/ChTradicional-T200.f03d00fb.gif";